import { Link } from 'react-router-dom';
import { useComponents } from '../api/hooks';
import { Badge } from '../components/Badge';
import { Card } from '../components/Card';
import type { Component } from '../api/types';

export default function Components() {
  const { data, isLoading, error } = useComponents();

  if (isLoading || !data) return <p className="text-arcforge-500">載入中…</p>;
  if (error) return <p className="text-red-600">錯誤：{(error as Error).message}</p>;

  const core = data.filter((c) => c.type === 'core');
  const addon = data.filter((c) => c.type === 'addon');

  return (
    <div className="space-y-8">
      <section>
        <h2 className="text-xl font-bold text-arcforge-700 mb-3">
          Core 元件 ({core.length})
        </h2>
        {core.length === 0 ? (
          <p className="text-arcforge-500 text-sm">尚未註冊 core 元件</p>
        ) : (
          <div className="grid gap-3 md:grid-cols-2">
            {core.map((c) => (
              <ComponentCard key={c.id} c={c} />
            ))}
          </div>
        )}
      </section>

      <section>
        <h2 className="text-xl font-bold text-arcforge-700 mb-3">
          Addon 元件 ({addon.length})
        </h2>
        {addon.length === 0 ? (
          <p className="text-arcforge-500 text-sm">
            尚未建立 addon（Phase 3 會加 drink-order 和 admin-dashboard）
          </p>
        ) : (
          <div className="grid gap-3 md:grid-cols-2">
            {addon.map((c) => (
              <ComponentCard key={c.id} c={c} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

function ComponentCard({ c }: { c: Component }) {
  const m = c.manifest_json;
  return (
    <Link to={`/components/${c.id}`} className="block">
      <Card className="transition hover:border-arcforge-500 hover:shadow-md">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-arcforge-700">{c.id}</h3>
          <Badge tone={c.type}>{c.type}</Badge>
        </div>
        <p className="mt-2 text-sm text-arcforge-500 line-clamp-2">
          {m.description}
        </p>
        {m.requires && m.requires.length > 0 && (
          <p className="mt-3 text-xs text-arcforge-500">
            依賴：{m.requires.join(', ')}
          </p>
        )}
        <p className="mt-1 text-xs text-arcforge-500">v{m.version}</p>
      </Card>
    </Link>
  );
}
